import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { SiaJsEditorComponent } from '@sia/code-editor';
import { SiaCheckBoxComponent, SiaSelectBoxComponent } from '@sia/inputs';
import { jsonDeepClone, SiaTranslatePipe } from '@sia/shared';
import { SiaItemAction } from '../../interfaces/sia-item-action';

@Component({
  selector: 'sia-action-properties-dialog',
  standalone: true,
  imports: [
    SiaSelectBoxComponent,
    SiaCheckBoxComponent,
    SiaJsEditorComponent,
    MatButton,
    MatDialogTitle,
    MatDialogActions,
    MatDialogContent,
    SiaTranslatePipe,
  ],
  templateUrl: './sia-action-properties-dialog.component.html',
  styleUrl: './sia-action-properties-dialog.component.scss',
})
export class SiaActionPropertiesDialogComponent {
  originalAction = inject<SiaItemAction>(MAT_DIALOG_DATA);
  dialogRef =
    inject<MatDialogRef<SiaActionPropertiesDialogComponent>>(MatDialogRef);

  pageModesSelect: { id: string; description: string }[] = [
    { id: 'read', description: 'read' },
    { id: 'update', description: 'update' },
    { id: 'create', description: 'create' },
  ];
  actionStyles: { id: string; description: string }[] = [
    { id: 'flat', description: 'Flat primaria' },
    { id: 'stroked-error', description: 'Stroked errore' },
    { id: 'list', description: 'Lista mat-menu' },
    { id: 'template', description: 'Template' },
  ];
  action: SiaItemAction;

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {
    const originalAction = this.originalAction;

    // dialogRef.updateSize('min(90%,1000px)', 'min(90%,1000px)');
    this.action = jsonDeepClone(originalAction);
  }

  closeDialog() {
    this.dialogRef.close(null);
  }
  saveAction() {
    this.dialogRef.close(this.action);
  }
}
